import React, { useState } from "react";

//
//
import CityOrganicGrid from "./CityOrganicGrid";
import CityOrganicModal from "./CityOrganicModal";

//

function CityOrganic() {
  //
  //

  const [selectedImgCityOrganic, setSelectedImgCityOrganic] = useState(null);

  return (
    <React.Fragment>
      <CityOrganicGrid setSelectedImgCityOrganic={setSelectedImgCityOrganic} />
      {/* 
      
      
      
      
      
      */}
      {selectedImgCityOrganic && (
        <CityOrganicModal
          selectedImgCityOrganic={selectedImgCityOrganic}
          setSelectedImgCityOrganic={setSelectedImgCityOrganic}
        />
      )}
    </React.Fragment>
  );
}

export default CityOrganic;
